import React from 'react';

import { RequestBoostedPriorityEnum } from '@constants';

import { PriorityBolt } from '../priority-bolt';
import { PriorityFire } from '../priority-fire';

const DECORATIONS: { [priority: string]: React.ReactElement } = {
  [RequestBoostedPriorityEnum.VeryHigh]: <PriorityFire />,
  [RequestBoostedPriorityEnum.Critical]: <PriorityBolt />,
};

interface PriorityDecorationProps {
  priority: string;
}

const PriorityDecoration: React.FC<PriorityDecorationProps> = ({ priority }) => DECORATIONS[priority] || null;

export default PriorityDecoration;
